import React from 'react';
import queryString from 'query-string';
import { apiPost, startApiSession } from '../../services/apiClient';

export default class LoginSSO extends React.Component {
    componentDidMount() {
		let queryValues = queryString.parse(this.props.location.search);
        let data = {
            data: queryValues.data
        };
        apiPost('auth/sso', data)
            .then(response => {
                startApiSession(response.accessToken, response.refreshToken, true);
            })
            .catch(error => {
				this.props.history.push({
					pathname: '/login',
					state: { ssoFailed: true }
				});
            });
    }

    render() {
        return (
            <div className="loading">
                <img src="/img/spinner.gif" alt="loading" />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/login/ssoLogin.jsx